import logo from "@/assets/VVV/vvv-black-with-text.png";
import ceoSignature from "@/assets/VVV/images/sgntr.png";
import jsPDF from "jspdf";

const highlightText = (
  doc,
  text,
  x,
  y,
  highlightColor = [255, 255, 0],
  paddingX = 1,
  paddingY = 0
) => {
  doc.setFillColor(...highlightColor);

  const textWidth = doc.getTextWidth(text);
  const textHeight = doc.internal.getFontSize();

  doc.rect(
    x - textWidth / 2 - paddingX,
    y - textHeight / 2 - paddingY,
    textWidth + 2 * paddingX,
    textHeight + 2 * paddingY,
    "F"
  );

  doc.setTextColor(0, 0, 0);
  doc.text(text, x, y, { align: "center" });
};

export const ealryPayoutContract = (user, ipAddress, signature) => {
  const doc = new jsPDF();

  const currentDate = new Date().toLocaleDateString();
  const currentTime = new Date().toLocaleTimeString();

  doc.setFontSize(18);
  doc.setFont("Helvetica", "bold");

  doc.addImage(logo, "PNG", 64, 10, 80, 20);

  doc.setFontSize(16);
  doc.text("Terms of Agreement for", doc.internal.pageSize.getWidth() / 2, 40, {
    align: "center",
  });

  doc.text("Early Payout", doc.internal.pageSize.getWidth() / 2, 50, {
    align: "center",
  });

  doc.setFontSize(14);
  doc.setFont("Helvetica", "bold");
  doc.text(
    `This agreement is made effective as of ${currentDate} between VeryViralVideos and ${user.firstName} ${user.lastName}.`,
    15,
    65,
    { maxWidth: 180 }
  );

  // Add your terms content
  doc.setFontSize(12);
  doc.setFont("Helvetica", "normal");
  doc.text(
    "By submitting an Early Pay request, you acknowledge and agree to the following:",
    15,
    84,
    { maxWidth: 180 }
  );

  // Overview
  doc.setFont("Helvetica", "bold");
  doc.text("Overview", 15, 100);
  doc.setFont("Helvetica", "normal");
  doc.text(
    "Early Pay allows you to receive a lump sum of your estimated YouTube earnings before the standard payout period.",
    25,
    108,
    { maxWidth: 170 }
  );

  // 1. Advance Terms
  doc.setFont("Helvetica", "bold");
  doc.text("1. Advance Terms", 15, 122);
  doc.setFont("Helvetica", "normal");
  doc.text("• The payout is based on your expected revenue.", 25, 130);
  doc.text(
    "• A 2.5% service fee will be applied to the total advance.",
    25,
    138
  );

  // 2. Approval Process
  doc.setFont("Helvetica", "bold");
  doc.text("2. Approval Process", 15, 147);
  doc.setFont("Helvetica", "normal");
  doc.text(
    "All requests are reviewed. Approval depends on your channel performance, payout history, and compliance standing.",
    25,
    155,
    { maxWidth: 170 }
  );

  // 3. Offset & Reconciliation
  doc.setFont("Helvetica", "bold");
  doc.text("3. Offset & Reconciliation", 15, 169);
  doc.setFont("Helvetica", "normal");
  doc.text(
    "The advance will be deducted from your future YouTube payout. If your actual earnings are lower than the advance, you may be required to settle the remaining balance.",
    25,
    177,
    { maxWidth: 170 }
  );

  // 4. Verification Requirements
  doc.setFont("Helvetica", "bold");
  doc.text("4. Verification Requirements", 15, 191);
  doc.setFont("Helvetica", "normal");
  doc.text(
    "Identity verification or documentation may be required. False submissions may result in denial or account limitations.",
    25,
    199,
    { maxWidth: 170 }
  );

  // 5. Not a Loan
  doc.setFont("Helvetica", "bold");
  doc.text("5. Not a Loan", 15, 214);
  doc.setFont("Helvetica", "normal");
  doc.text(
    "This is an advance on your own projected income, not a loan. You agree to use the funds responsibly.",
    25,
    222,
    { maxWidth: 170 }
  );

  // 6. Policy Changes
  doc.setFont("Helvetica", "bold");
  doc.text("6. Policy Changes", 15, 236);
  doc.setFont("Helvetica", "normal");
  doc.text(
    "VeryViralVideos may revise these terms at any time. You’ll be notified of any key changes prior to your next request.",
    25,
    244,
    { maxWidth: 170 }
  );

  // 7. Data Privacy Policy
  doc.setFont("Helvetica", "bold");
  doc.text("7. Data Privacy Policy", 15, 258);
  doc.setFont("Helvetica", "normal");
  doc.text(
    "VeryViralVideos collects and processes personal data such as government-issued ID, financial information, and account details solely for the purposes of identity verification, payout processing, and fraud prevention.",
    25,
    266,
    { maxWidth: 170 }
  );

  doc.addPage();
  doc.text(
    "All personal data is securely stored and handled in accordance with applicable data protection laws (e.g., the Philippine Data Privacy Act, GDPR if applicable).",
    25,
    25,
    { maxWidth: 174 }
  );
  doc.text(
    "Your information will not be sold or shared with third parties without your consent, except where legally required.",
    25,
    40,
    { maxWidth: 178 }
  );

  // Signature section
  doc.setFontSize(13);
  doc.text(
    "Signee's Signature Information",
    doc.internal.pageSize.getWidth() / 15,
    65,
    { maxWidth: 180 }
  );

  doc.text(
    `Name: ${user.firstName} ${user.lastName}`,
    doc.internal.pageSize.getWidth() / 15,
    79,
    { maxWidth: 180 }
  );

  doc.text("Signature:", doc.internal.pageSize.getWidth() / 15, 89, {
    maxWidth: 180,
  });

  doc.addImage(signature, "PNG", 20, 95, 100, 30);

  doc.text(
    `via ${ipAddress} (${user.email})`,
    doc.internal.pageSize.getWidth() / 15,
    130,
    { maxWidth: 180 }
  );

  doc.setFontSize(14);
  highlightText(doc, `Acquired on ${currentDate} ${currentTime}`, 52, 145);

  doc.setFontSize(13);
  doc.setFont("Helvetica", "bold");
  doc.text(
    "VeryViralVideos Authorized Signee: Jake W. Jones, CEO",
    doc.internal.pageSize.getWidth() / 15,
    180
  );

  doc.addImage(ceoSignature, "PNG", 15, 190, 100, 18);

  const pdfBlob = doc.output("blob");
  const file = new File(
    [pdfBlob],
    `Advance_Payout_Agreement_${user.firstName}_${user.lastName}_${user.email}.pdf`,
    {
      type: "application/pdf",
    }
  );

  // const pdfUrl = URL.createObjectURL(pdfBlob);
  // window.open(pdfUrl);

  return file;
};
